import {z} from 'zod'

export const savedLocationRawSchema = z.object({
    id: z.string(),
    location_id: z.string(),
    name: z.string(),
    notes: z.string().nullable(),
    latitude: z.number(),
    longitude: z.number(),
    full_address: z.string().nullable(),
    created_at: z.string(),
})

export const savedLocationSchema = savedLocationRawSchema.transform((raw) => ({
    id: raw.id,
    locationId: raw.location_id,
    name: raw.name,
    notes: raw.notes,
    latitude: raw.latitude,
    longitude: raw.longitude,
    fullAddress: raw.full_address,
    createdAt: raw.created_at,
}))

export const createSavedLocationRequestSchema = z.object({
    name: z.string().trim().min(1),
    location_id: z.string().uuid().nullable().optional(),
    latitude: z.number().nullable().optional(),
    longitude: z.number().nullable().optional(),
    full_address: z.string().trim().nullable().optional(),
    notes: z.string().trim().nullable().optional(),
})

export const updateSavedLocationRequestSchema = z.object({
    name: z.string().trim().min(1),
    location_id: z.string().uuid().nullable().optional(),
    latitude: z.number().nullable().optional(),
    longitude: z.number().nullable().optional(),
    full_address: z.string().trim().nullable().optional(),
    notes: z.string().trim().nullable().optional(),
})

export type SavedLocationRaw = z.infer<typeof savedLocationRawSchema>
export type SavedLocation = z.infer<typeof savedLocationSchema>

export type CreateSavedLocationInput = {
    name: string
    locationId?: string
    latitude?: number
    longitude?: number
    fullAddress?: string
    notes?: string
}

export type UpdateSavedLocationInput = {
    name: string
    locationId?: string
    latitude?: number
    longitude?: number
    fullAddress?: string
    notes?: string
}

export function toCreateSavedLocationRequest(input: CreateSavedLocationInput) {
    return createSavedLocationRequestSchema.parse({
        name: input.name,
        location_id: input.locationId,
        latitude: input.latitude,
        longitude: input.longitude,
        ...(input.fullAddress !== undefined
            ? {full_address: input.fullAddress.trim() || null}
            : {}),
        notes: input.notes?.trim() || null,
    })
}

export function toUpdateSavedLocationRequest(input: UpdateSavedLocationInput) {
    return updateSavedLocationRequestSchema.parse({
        name: input.name,
        location_id: input.locationId,
        latitude: input.latitude,
        longitude: input.longitude,
        ...(input.fullAddress !== undefined
            ? {full_address: input.fullAddress.trim() || null}
            : {}),
        notes: input.notes?.trim() || null,
    })
}

export function createEmptySavedLocation(): CreateSavedLocationInput {
    return {
        name: '',
        locationId: undefined,
        latitude: undefined,
        longitude: undefined,
        fullAddress: undefined,
        notes: '',
    }
}
